import { Iconify } from '@btsis/ui';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export function ForbiddenPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card sx={{ p: 6 }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Iconify icon="solar:lock-keyhole-bold-duotone" width={56} sx={{ color: 'warning.main' }} />
        <Typography variant="h5">{t('error.forbiddenTitle')}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 420 }}>
          {t('error.PERMISSION_DENIED')}
        </Typography>
        <Button variant="contained" onClick={() => void navigate('/', { replace: true })}>
          {t('error.backToDashboard')}
        </Button>
      </Stack>
    </Card>
  );
}
